import { useState } from "react";
import SmartLink from "./SmartLink";
import Image from "./Image";
import { useReveal } from '../hooks/UseReveal';

export default function TeamMember({ person }) {

    const revealRef = useReveal({ once: true });
    const [isActive, setIsActive] = useState(false);
    const hasBiography = Boolean(person?.biography);

    const handleToggle = () => {
        if (!hasBiography) return;
        // Only toggle on touch devices where hover is unavailable
        if (window.matchMedia('(hover: none)').matches) {
            setIsActive((prev) => !prev);
        }
    };

    const handleMouseLeave = () => {
        if (!isActive) return;
        setIsActive(false);
    };

    const personRevealRef = useReveal({ once: true });

    return (
        <div
            className={`c-team-grid__person c-transition-in ${hasBiography ? 'state-has-biography' : ''} ${isActive ? 'state-is-active' : ''}`}
            ref={personRevealRef}
            onClick={handleToggle}
            onMouseLeave={handleMouseLeave}
        > 
            <div className="c-team-grid__person__inner">
                {person.image && (
                    <div className="c-team-grid__person__image">
                        <Image 
                            src={person.image}
                            alt={person.name}
                        />
                    </div>
                )}
                <div className="c-team-grid__person__info">
                    <h3 className="c-team-grid__person__name">{person.name}</h3>
                    <h4 className="c-team-grid__person__role">{person.role}</h4>
                    {person.biography && (
                        <div className="c-team-grid__person__biography scope-text scope-text--small" dangerouslySetInnerHTML={{__html: person.biography}} />
                    )}
                </div>
            </div>
        </div>

    )
}